import { Component, inject } from '@angular/core';

import { Router } from '@angular/router';
import { AmlService } from '../_services/aml.service';
import { IconService } from '../_services/icon.service';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { environment } from '../../environments/environment';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-signature-completed',
  standalone: true,
  imports: [MatIconModule, MatButtonModule, CommonModule],
  templateUrl: './signature-completed.component.html',
  styleUrl: './signature-completed.component.scss',
})
export class SignatureCompletedComponent {
  infocertBase = environment.infocertBase;

  private iconService = inject(IconService);
  public amlService = inject(AmlService);
  constructor() {
    this.iconService.getIcons(['pdf']);
  }
}
